import React from 'react';

interface MonoCellProps {
  children: React.ReactNode;
}

/** Renders machine identifiers in monospace with tabular numerals. */
const MonoCell: React.FC<MonoCellProps> = ({ children }) => (
  <span className="mono">{children}</span>
);

export default MonoCell;
